var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"white",attrs:{"id":"SectionWhyUsAbout"}},[_c('Wrap',{staticClass:"lg"},[_c('h4',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t('title'))+" ")]),_c('Row',_vm._l((_vm.reasons),function(reason){return _c('Column',{key:reason.label,attrs:{"md":6}},[_c('Reason',{attrs:{"reason":reason}})],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }